import "./Chip.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";

interface ChipProps {
  className?: string;
  isClosable?: boolean;
  onRequestClose?: (e?: React.MouseEvent) => void;
  children?: React.ReactNode;
}

// Will raise an error if no `onRequestClose` handler is provided.
// onRequestClose will only fire if `isClosable` is set to true.
// isClosable defaults to false.
// So defaultOnRequestClose will only fire if `isClosable` is set to true, and no `onRequestClose` handler is provided.
const defaultOnRequestClose = () =>
  console.error(`Chip needs an \`onRequestClose\` handler.`);

const Chip: React.FC<ChipProps> = ({
  children,
  className,
  isClosable = false,
  onRequestClose = defaultOnRequestClose,
}) => (
  <div className={classNames("Chip", className)}>
    <span className="Chip__content">
      <span className="Chip__content--inner">{children}</span>
    </span>
    {isClosable && (
      <button
        className="Chip__close"
        aria-label="Close Button"
        onClick={(e) => onRequestClose(e)}
      >
        <FontAwesomeIcon icon={"close"} />
      </button>
    )}
  </div>
);

export default Chip;
